export default "__VITE_ASSET__DAEWV7PL__"